import React from 'react';
import PropTypes from 'prop-types';

import {Box, Chip, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

const ContentView = (props) => {
  const bioQuestion = props.bioQuestion;

  const {bioQuestionId, questionData} = bioQuestion;

  const hasSelections = questionData.value.length > 0;

  return (

    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 0.5,
      }}
    >
      {
         hasSelections ?
          questionData.value.map((val) => (
            <Chip
              key={val}
              label={translate(`caregiver.CaregiverDetail.Biography.Questions.Options.${bioQuestionId}.${val}`)}
            />
          )) :
          <Typography>
            <Translate expression='caregiver.CaregiverDetail.Biography.Questions.Empty' />
          </Typography>
      }
    </Box>
  );
};

ContentView.propTypes = {
  bioQuestion: PropTypes.shape({
    bioQuestionId: PropTypes.string.isRequired,
    questionData: PropTypes.shape({
      value: PropTypes.array.isRequired,
    }).isRequired,
  }).isRequired,
};

export default ContentView;
